import HandleErrorApi from "./HandleErrorApi";

/**
 * API по отчетам
 */
class ReportApi {
    api = new HandleErrorApi();
    /**
     * Отчеты дашборда
     */
    getDashboardReports(data = {domain: null, base: null})
    {
        return this.api.get('/report/mass-report', data);
    }
    /**
     * PDF дашборда
     */
    getDashboardReportsPdf(data = {domain: null, base: null})
    {
        return this.api.get('/report/simple/domain_dashboard/pdf', data);
    }
    /**
     * Статус основного отчета (dashboard build state + aiState)
     */
    getState(data = {domain: null, base: null})
    {
        return this.api.get('/report/simple/state', data);
    }
    /**
     * Статус только ИИ-отчёта (оптимизированный endpoint)
     */
    getAiState(data = {domain: null, base: null})
    {
        return this.api.get('/report/simple/ai-answers/state', data);
    }
    /**
     * Статус только ИИ-конкурентов отчёта (оптимизированный endpoint)
     */
    getAiCompState(data = {domain: null, base: null})
    {
        return this.api.get('/report/simple/ai-comps/state', data);
    }
}

export default new ReportApi();
